import { useNavigate } from 'react-router-dom';
import { ButtonRow } from '../../../components/atoms/ButtonRow/ButtonRow';
import {
  type StyleSheet,
  useThemedComponent,
  ThemeContent,
} from '../../../providers/ThemeProvider';
import { useLoading } from '../../../providers/LoadingProvider';
import { useEffect } from 'react';

export default function NotFound() {
  const { styles } = useThemedComponent([NotFoundStyles]);
  const navigate = useNavigate();
  const { setLoading } = useLoading();

  useEffect(() => {
    setLoading(false);
  }, [setLoading]);
  return (
    <div style={{ ...styles.pageContainer, ...styles.container }}>
      <h1 style={styles.titleText}>404 Error</h1>
      <h1 style={styles.subtitleText}>Page not found</h1>
      <hr style={styles.divider} />
      <label>
        I’m sorry, the page you are looking for does not exist. Please return to
        the homepage
      </label>
      <ButtonRow
        buttons={[
          {
            title: 'Go to homepage',
            onClick: () => {
              navigate('/');
            },
            style: styles.backButton,
          },
        ]}
        style={styles.buttonRow}
      />
    </div>
  );
}

const NotFoundStyles = (theme: ThemeContent): StyleSheet => ({
  container: {
    gap: 10,
  },
  titleText: {
    fontSize: 36,
    fontWeight: 'bold',
    marginBottom: 8,
  },
  subtitleText: {
    fontSize: 24,
  },
  divider: {
    borderTopWidth: '1px',
    borderTopColor: theme.colors.coolGrey,
    width: '100%',
  },
  backButton: {
    backgroundColor: theme.colors.primary,
    color: theme.colors.white,
    borderRadius: 5,
    width: 250,
    height: 40,
    borderStyle: 'unset',
  },
  buttonRow: {
    marginTop: 64,
  },
});
